import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CardType} from "../../cards/card-type";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {Subject} from "rxjs";
import {AutocompleteLoadingModeType, IAutocompleteSchema, IDatepickerSchema} from "maps-angular-components";
import {Carteira} from "../../../carteira/carteira.model";
import {CarteiraService} from "../../../carteira/carteira.service";
import {EnquadradaDesenquadradaOutput} from "./EnquadradaDesenquadradaOutput";

@Component({
  selector: 'app-com-sem-regra-filtro',
  templateUrl: './com-sem-regra-filtro.component.html',
  styleUrls: ['./com-sem-regra-filtro.component.scss']
})
export class ComSemRegraFiltroComponent {
  @Input() titulo: string;
  @Input() cardType: CardType = CardType.NENHUM;
  @Output() onSearch: EventEmitter<EnquadradaDesenquadradaOutput> =
    new EventEmitter<EnquadradaDesenquadradaOutput>();

  form: FormGroup;

  @Output() searchEvent = new EventEmitter<number>();
  private pageNumber = 1;

  loading$: Subject<boolean> = new Subject<boolean>();

  public carteiraSchema: IAutocompleteSchema<Carteira>;

  constructor(
    private formBuilder: FormBuilder,
    private carteiraService: CarteiraService
  ) {

    this.form = this.formBuilder.group({
      id: new FormControl()
    });

    this.carteiraSchema = {
      service: this.carteiraService,
      label: "Nome",
      placeholder: "Nome da carteira",
      loadingMode: AutocompleteLoadingModeType.LAZY,
      autoload: false,
      endpoint: "nome-ou-cnpj",
      formGroup: this.form,
      formControlName: "id",
      panelClass: "w-100",
      parseSearchParam(search): string {
        return search;
      },
    };
  }

  pesquisar(value: any) {
    this.onSearch.emit(Object.assign({}, value));
    this.searchEvent.emit(this.pageNumber);
  }

  getOutputNoInput() {
    return this.getOutput(this.form.value);
  }

  getOutput(value: any) {
    let output = new EnquadradaDesenquadradaOutput();
    if (value.carteira !== null && value.carteira != undefined) {
      output.id = value.carteira.id;
    }
    return output;
  }
}
